if (!customElements.get('age-verification')) {
  customElements.define('age-verification', class AgeVerification extends HTMLElement {
    constructor() {
      super();

      this.modalParent = this.closest('[data-modal]');
      this.modalParent.addEventListener('ageVerification:open', this.init.bind(this));
    }

    init() {
      // Age verification can be triggered from multiple sources so we need to attach the event listeners here
      this.productFormId = this.modalParent.getAttribute('data-target-form');
      this.productForm = document.getElementById(this.productFormId);
      this.productFormSubmit = this.productForm.querySelector('button[type="submit"]');
      this.rejectButton = this.querySelector('[name="age-restriction-reject"]');
      this.confirmButton = this.querySelector('[name="age-restriction-confirm"]');
      this.rejectButton.addEventListener('click', this.onRejectHandler.bind(this));
      this.confirmButton.addEventListener('click', this.onConfirmHandler.bind(this));
    }

    onRejectHandler(evt) {
      evt.preventDefault();
      sessionStorage.setItem('ageVerified', 'false');
      Woolman.ModalsAndDrawers.closeModalOrDrawer(this.modalParent.getAttribute('id'));
    }

    onConfirmHandler(evt) {
      evt.preventDefault();
      sessionStorage.setItem('ageVerified', 'true');
      Woolman.ModalsAndDrawers.closeModalOrDrawer(this.modalParent.getAttribute('id'));
      this.productFormSubmit.click();
    }
  });
}